module.exports = __webpack_public_path__ + "img/15.6f87a472.jpg";